export default __webpack_public_path__ + "static/logo35-66408d9332bb9f7de9022fe07eb82a37.png";